export const PRIZE_OPTIONS = [
  'The Booker Prize',
  'Women\'s Prize for Fiction',
  'Baillie Gifford Prize',
  'International Booker Prize',
  'Pulitzer Prize for Fiction',
  'Pulitzer Prize for History',
  'Pulitzer Prize for Biography',
  'Pulitzer Prize for General Nonfiction',
  'Pulitzer Prize for Memoir',
  'National Book Award for Fiction',
  'National Book Award for Nonfiction',
  'National Book Award for Poetry',
  'National Book Award for Translated Literature',
  'National Book Award for Young People\'s Literature',
  'Dylan Thomas Prize',
  'Goldsmiths Prize',
  'Scotiabank Giller Prize',
  'Nobel Prize in Literature',
];
